import "./index.css"
import Logo from "../images/feemonk-logo2.png"

function MandateInProgress() {
  return (
   
<html lang="en">
<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Mandate in Progress</title>
  <link rel="stylesheet" href="styles.css" />
</head>
<body>

  <div className="page-wrapper">
    <div className="card">
    <div className="logo-div">
      <img src={Logo} alt="Feemonk" className="logo" />

      </div>

      <h1>MANDATE IN PROGRESS</h1>
      <div className="status-icon">⏳</div>

      <p className="primary-text">
        Your mandate has already been raised and is currently
        being processed by the bank.
      </p>

      <p className="highlight-text">
        Payments cannot be accepted at this time.
      </p>

      <p className="secondary-text">
        Once the mandate is approved, your EMI will be auto-debited as scheduled.
        No action is required from your side right now.
      </p>

      <a href="https://partner.feemonk.com/login" className="secondary-link">
        Go to Customer Portal
      </a>

      <p className="support-text">
        Need help? Contact us at <strong>hello@feemonk.com</strong>
      </p>

    </div>
  </div>

</body>
</html>

  );
}

export default MandateInProgress;
